"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewDriver = exports.FormDriver = void 0;

var axios_1 = __importDefault(require("axios"));

var nanoid_1 = require("nanoid");

var Qore_1 = require("./Qore");

var FormDriver =
/** @class */
function () {
  function FormDriver(project, viewId, formId) {
    this.project = project;
    this.viewId = viewId;
    this.formId = formId;
  }

  FormDriver.prototype.sendForm = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var resp;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.project.axios.post("/" + this.viewId + "/forms/" + this.formId, params)];

          case 1:
            resp = _a.sent();
            return [2
            /*return*/
            , resp.data];
        }
      });
    });
  };

  return FormDriver;
}();

exports.FormDriver = FormDriver;

var ViewDriver =
/** @class */
function () {
  function ViewDriver(client, project, id, tableId, fields) {
    var _this = this;

    this.fields = {};
    this.client = client;
    this.id = id;
    this.tableId = tableId;
    this.project = project; // @ts-ignore

    this.forms = {};
    this.fields = fields.reduce(function (map, field) {
      var _a;

      return __assign(__assign({}, map), (_a = {}, _a[field.id] = field, _a));
    }, {});
    this.actions = new Proxy({}, {
      get: function get(actions, key) {
        if (!actions[key]) {
          // @ts-ignore
          actions[key] = _this.createAction(key);
        }

        return actions[key];
      }
    });

    for (var _i = 0, _a = Object.entries(this.fields).filter(function (_a) {
      var _ = _a[0],
          field = _a[1];
      return field.type === "action";
    }); _i < _a.length; _i++) {
      var key = _a[_i][0]; // @ts-ignore

      this.actions[key] = this.createAction(key);
    }
  }

  ViewDriver.prototype.action = function (actionId) {
    if (!this.actions[actionId]) {
      // @ts-ignore
      this.actions[actionId] = this.createAction(actionId);
    }

    return this.actions[actionId];
  };

  ViewDriver.prototype.createAction = function (fieldID) {
    var _this = this;

    return {
      trigger: function trigger(rowId, params) {
        return __awaiter(_this, void 0, void 0, function () {
          var axiosConfig, operation, res;

          var _a;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                axiosConfig = {
                  url: "/" + this.id + "/rows/" + rowId + "/" + fieldID,
                  data: params,
                  method: "POST"
                };
                operation = {
                  key: JSON.stringify(axiosConfig),
                  request: axiosConfig,
                  type: axiosConfig.method,
                  meta: {},
                  pollInterval: 0,
                  networkPolicy: "network-only"
                };
                return [4
                /*yield*/
                , this.client.execute(operation).toPromise()];

              case 1:
                res = _b.sent();
                if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.isExecuted) return [2
                /*return*/
                , true];
                if (res.error) throw res.error;
                throw new Error("Trigger has failed");
            }
          });
        });
      }
    };
  };

  ViewDriver.prototype.form = function (formId) {
    if (!this.forms[formId]) {
      this.forms[formId] = new FormDriver(this.project, this.id, formId);
    }

    return this.forms[formId];
  };

  ViewDriver.prototype.readRows = function (opts, config) {
    var _this = this;

    if (opts === void 0) {
      opts = {};
    }

    if (config === void 0) {
      config = Qore_1.defaultOperationConfig;
    }

    var axiosConfig = {
      url: "/" + this.id + "/rows",
      params: opts,
      method: "GET"
    };

    var operation = __assign({
      key: JSON.stringify(axiosConfig),
      request: axiosConfig,
      type: axiosConfig.method,
      meta: {}
    }, __assign(__assign({}, Qore_1.defaultOperationConfig), config));

    var stream = this.client.execute(operation);

    stream.fetchMore = function (fetchMoreOpts) {
      return __awaiter(_this, void 0, void 0, function () {
        var existingItems, moreItems;

        var _a, _b;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , stream.revalidate({
                networkPolicy: "cache-only"
              })];

            case 1:
              existingItems = _c.sent();
              return [4
              /*yield*/
              , this.readRows(fetchMoreOpts, config).toPromise()];

            case 2:
              moreItems = _c.sent();
              return [4
              /*yield*/
              , stream.revalidate({
                networkPolicy: "cache-only",
                optimisticResponse: {
                  nodes: __spreadArrays(((_a = existingItems.data) === null || _a === void 0 ? void 0 : _a.nodes) || [], ((_b = moreItems.data) === null || _b === void 0 ? void 0 : _b.nodes) || [])
                }
              })];

            case 3:
              _c.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return stream;
  };

  ViewDriver.prototype.readRow = function (id, config) {
    if (config === void 0) {
      config = Qore_1.defaultOperationConfig;
    }

    var axiosConfig = {
      url: "/" + this.id + "/rows/" + id,
      method: "GET"
    };

    var operation = __assign({
      key: JSON.stringify(axiosConfig),
      request: axiosConfig,
      type: axiosConfig.method,
      meta: {}
    }, __assign(__assign({}, Qore_1.defaultOperationConfig), config));

    return this.client.execute(operation);
  };

  ViewDriver.prototype.updateRow = function (id, input) {
    return __awaiter(this, void 0, void 0, function () {
      var axiosConfig, operation, patchError, row;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            axiosConfig = {
              url: "/" + this.id + "/rows/" + id,
              data: input,
              method: "PATCH"
            };
            operation = {
              key: JSON.stringify(axiosConfig),
              request: axiosConfig,
              type: axiosConfig.method,
              meta: {},
              pollInterval: 0,
              networkPolicy: "network-only"
            };
            return [4
            /*yield*/
            , this.client.execute(operation).toPromise()];

          case 1:
            patchError = _a.sent().error;
            if (patchError) throw patchError;
            return [4
            /*yield*/
            , this.readRow(id).toPromise()];

          case 2:
            row = _a.sent();
            if (!row.data) throw row.error;
            return [2
            /*return*/
            , row.data];
        }
      });
    });
  };

  ViewDriver.prototype.deleteRow = function (id) {
    return __awaiter(this, void 0, void 0, function () {
      var axiosConfig, operation, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            axiosConfig = {
              url: "/" + this.id + "/rows/" + id,
              method: "DELETE"
            };
            operation = {
              key: JSON.stringify(axiosConfig),
              request: axiosConfig,
              type: axiosConfig.method,
              meta: {},
              pollInterval: 0,
              networkPolicy: "network-only"
            };
            return [4
            /*yield*/
            , this.client.execute(operation).toPromise()];

          case 1:
            res = _a.sent();
            if (res.error) throw res.error;
            return [2
            /*return*/
            , true];
        }
      });
    });
  };

  ViewDriver.prototype.insertRow = function (input) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var axiosConfig, operation, result, row;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            axiosConfig = {
              url: "/" + this.id + "/rows",
              data: input,
              method: "POST"
            };
            operation = {
              key: JSON.stringify(axiosConfig),
              request: axiosConfig,
              type: axiosConfig.method,
              meta: {},
              pollInterval: 0,
              networkPolicy: "network-only"
            };
            return [4
            /*yield*/
            , this.client.execute(operation).toPromise()];

          case 1:
            result = _b.sent();
            if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.id)) throw result.error;
            return [4
            /*yield*/
            , this.readRow(result.data.id).toPromise()];

          case 2:
            row = _b.sent();
            if (!row.data) throw row.error;
            return [2
            /*return*/
            , row.data];
        }
      });
    });
  };

  ViewDriver.prototype.addRelation = function (rowId, relations) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Promise.all(Object.entries(relations).flatMap(function (_a) {
              var field = _a[0],
                  refs = _a[1];
              return refs.map(function (ref) {
                var axiosConfig = {
                  baseURL: _this.project.config.endpoint,
                  url: "/" + _this.project.config.projectId + "/" + _this.id + "/rows/" + rowId + "/" + field + "/" + ref,
                  method: "POST"
                };
                return _this.project.axios(axiosConfig);
              });
            }))];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , true];
        }
      });
    });
  };

  ViewDriver.prototype.removeRelation = function (rowId, relations) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Promise.all(Object.entries(relations).flatMap(function (_a) {
              var field = _a[0],
                  refs = _a[1];
              return refs.map(function (ref) {
                var axiosConfig = {
                  baseURL: _this.project.config.endpoint,
                  url: "/" + _this.project.config.projectId + "/" + _this.id + "/rows/" + rowId + "/" + field + "/" + ref,
                  method: "DELETE"
                };
                return _this.project.axios(axiosConfig);
              });
            }))];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , true];
        }
      });
    });
  };

  ViewDriver.prototype.generateFileUrl = function (filename) {
    return __awaiter(this, void 0, void 0, function () {
      var axiosConfig, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            axiosConfig = {
              baseURL: this.project.config.endpoint,
              url: "/" + this.project.config.projectId + "/" + this.id + "/upload-url?fileName=" + filename,
              method: "GET"
            };
            return [4
            /*yield*/
            , this.project.axios(axiosConfig)];

          case 1:
            result = _a.sent();
            return [2
            /*return*/
            , result.data.url];
        }
      });
    });
  };

  ViewDriver.prototype.upload = function (file) {
    return __awaiter(this, void 0, void 0, function () {
      var ext, uploadUrl, url;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ext = file.name.split(".").reverse()[0];
            return [4
            /*yield*/
            , this.generateFileUrl(nanoid_1.nanoid() + "." + ext)];

          case 1:
            uploadUrl = _a.sent();
            return [4
            /*yield*/
            , axios_1.default.put(uploadUrl, file, {
              headers: {
                "Content-Type": file.type
              }
            })];

          case 2:
            _a.sent();

            url = uploadUrl.split("?")[0];
            return [2
            /*return*/
            , url];
        }
      });
    });
  };

  return ViewDriver;
}();

exports.ViewDriver = ViewDriver;